
<template>
  <div class="UsuariosForm">
    <div v-if="isOnline">
      <md-card>
        <md-card-header>
          <div class="md-title">{{legal.id ? 'Editar':'Registra'}} documento legal</div>
        </md-card-header>
        <md-card-content>
          <md-field :class="errores.titulo_leg">
            <label>Título</label>
            <md-input
              v-model="legal.titulo_leg"
              required
            />
          </md-field>
          <md-field :class="errores.tipo_leg">
            <label>Tipo de documento</label>
            <md-input
              v-model="legal.tipo_leg"
              required
            />
          </md-field>
        </md-card-content>
        <ckeditor
          :editor="editor"
          v-model="legal.contenido_leg"
          :config="editorConfig"
        />
        <md-card-actions>
          <md-button to="/legales">Cancelar</md-button>
          <md-button
            class="md-raised md-primary"
            @click="_presave"
          >
            {{legal.id ? 'Actualizar':'Guardar'}}
          </md-button>
        </md-card-actions>
      </md-card>
      <Loading v-if="cargando" />
    </div>
    <InternetRequired v-else />
  </div>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import InternetRequired from "@/components/InternetRequired";
import Loading from "@/components/Loading";
export default {
  name: "UsuariosForm",
  components: { Loading, InternetRequired },
  methods: {
    _falloResponse(err) {
      this.cargando = false;
      if (err.status === 401) {
        this.$router.push("/login");
      } else {
        this.$emit("msg", this.$no_internet);
      }
    },
    _obtenerLegal() {
      this.cargando = true;
      this.$http.get("legal/" + this.$route.params.idLegal, this.$headers).then(
        res => {
          this.cargando = false;
          if (res.status === 401) {
            this.$router.push("/login");
          } else if (res.status === 200 && "legal" in res.body) {
            this.legal = res.body.legal;
          } else {
            this.$emit("msg", res.body.error);
          }
        },
        err => this._falloResponse(err)
      );
    },
    _validar() {
      this.errores.titulo_leg = this.$mdError(this.legal.titulo_leg);
      this.errores.tipo_leg = this.$mdError(this.legal.tipo_leg);
      this.errores.contenido_leg = this.$mdError(this.legal.contenido_leg);
      return this.$validate(this.errores);
    },
    _presave() {
      if (this._validar()) {
        this.legal.id ? this._actualizar() : this._guardar();
      }
    },
    _guardar() {
      this.$http.post("legal", { legal: this.legal }, this.$headers).then(
        res => {
          this.cargando = false;
          if (res.status === 401) {
            this.$router.push("/login");
          } else if (res.status === 201 && "id" in res.body) {
            this.$emit("msg", res.body.msg);
            this.$router.push("/legales");
          } else {
            this.$emit("msg", res.body.error);
          }
        },
        err => this._falloResponse(err)
      );
    },
    _actualizar() {
      this.$http
        .put("legal/" + this.legal.id, { legal: this.legal }, this.$headers)
        .then(
          res => {
            this.cargando = false;
            if (res.status === 401) {
              this.$router.push("/login");
            } else if (res.status === 200 && "msg" in res.body) {
              this.$emit("msg", res.body.msg);
              this.$router.push("/legales");
            } else {
              this.$emit("msg", res.body.error);
            }
          },
          err => this._falloResponse(err)
        );
    }
  },
  data() {
    return {
      cargando: false,
      editor: ClassicEditor,
      editorConfig: {
        // The configuration of the rich-text editor.
      },
      legal: {
        id: null,
        id_leg: null,
        titulo_leg: null,
        tipo_leg: null,
        contenido_leg: ""
      },
      errores: {
        titulo_leg: null,
        tipo_leg: null,
        contenido_leg: ""
      }
    };
  },
  created() {
    if (this.$route.params.idLegal) {
      this._obtenerLegal();
    }
  },
  beforeCreate() {
    if (!this.$session.exists() && !this.$session.get("tipo")) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  }
};
</script>